import { ConfigProvider, message } from "antd";
import "antd/dist/reset.css";
import arEG from 'antd/locale/ar_EG';
import enUS from 'antd/locale/en_US';
import React, { Suspense, useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "styled-components";
import { primaryColor, ProjectName, secondaryColor } from "./config";
import { persistor, store } from "./redux/store";
import Routers from "./routers";
import GlobalStyles from "./styles/GlobalStyles";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { MakeApiCall } from "./apis";
import { useLocation } from "react-router-dom";
import "react-international-phone/style.css";
import LogoAnimation from "./components/logo-animation";
import "./i18n";
import { LanguageProvider } from "./contexts/LanguageContext";
import SellerHubChatWidget from "./components/chat/SellerHubChatWidget";

dayjs.extend(isoWeek);

// AppContent component to access Redux state
const AppContent = () => {
  const languageState = useSelector((state) => state.language);
  
  const handleLoad = () => {
    console.log("Page fully loaded including stylesheets, images, etc.");
  };

  useEffect(() => {
    window.addEventListener("load", handleLoad);
    return () => {};
  }, []);

  const sallWebhookApi = async () => {
    const response = await MakeApiCall(`salla-webhook`, "post", null, false);
    if (response?.status) {
      message.destroy();
      // message.success(response?.message);
    } else {
      message.destroy();
      // message.error(response?.message);
    }
  };

  const zidlWebhookApi = async () => {
    const response = await MakeApiCall(`zid-webhook`, "get", null, false);
    if (response?.status) {
      message.destroy();
      // message.success(response?.message);
    } else {
      message.destroy();
      // message.error(response?.message);
    }
  };

  return (
    <ConfigProvider
      direction={languageState?.direction || 'ltr'}
      locale={languageState?.language === 'ar' ? arEG : enUS}
      theme={{
        token: {
          fontFamily: `"Assistant", sans-serif`,
          colorPrimary: primaryColor,
          colorPrimaryHover: secondaryColor,
        },
        components: {
          Input: {
            borderRadius: "8px",
          },
          Button: {
            borderRadius: "8px",
          },
          InputNumber: {
            borderRadius: "8px",
          },
          Dropdown: {
            borderRadius: "8px",
          },
          DatePicker: {
            borderRadius: "8px",
          },
          Upload: {
            borderRadius: "8px",
          },
          Select: {
            borderRadius: "8px",
            colorTextPlaceholder: "#0000008c",
          },
        },
      }}
    >
      <ThemeProvider theme={{ direction: languageState?.direction || 'ltr' }}>
        <GlobalStyles direction={languageState?.direction || 'ltr'} />
        <LanguageProvider>
          <Suspense fallback={<LogoAnimation />}>
            <Routers />
          </Suspense>
          <SellerHubChatWidget />
        </LanguageProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  document.title = ProjectName;

  return (
    <Provider store={store}>
      <PersistGate loading={<LogoAnimation />} persistor={persistor}>
        <AppContent />
      </PersistGate>
    </Provider>
  );
}

export default App;
